<!-- 物理因素接触限值脉冲噪声 -->
<template>
  <div class="tableBoxShadow">
    <h5 :class="['title',{mobileFontSize:$isMobile}]">工作场所脉冲噪声职业接触限值</h5>
    <el-table :class="{mobileTable:$isMobile}" border :data="tableData" style="width: 100%">
      <el-table-column align="center" prop="touchTimes" label="工作日接触脉冲次数（n，次）">
      </el-table-column>
      <el-table-column align="center" prop="peakSoundPressureLevel" label="声压级峰值[dB(A)]">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  export default{
    data(){
      return{
        tableData:[]
      }
    },
    created() {
      this.findImpulseNoise()
    },
    methods:{
      async findImpulseNoise(){
        let res = await this.$axios.get(this.$serviceAPI.findImpulseNoise)
        this.tableData = res.data.data
      }
    },
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/subPage/impulseNoise.vue